var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.92 58.6666C46.6476 58.6666 58.5867 46.7275 58.5867 31.9999C58.5867 17.2723 46.6476 5.33325 31.92 5.33325C17.1924 5.33325 5.25336 17.2723 5.25336 31.9999C5.25336 46.7275 17.1924 58.6666 31.92 58.6666Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3066 32.6133V28.1599C23.3066 22.6133 27.2266 20.3466 32.0266 23.1199L35.8933 25.3599L39.76 27.5999C44.56 30.3733 44.56 34.9066 39.76 37.6799L35.8933 39.9199L32.0266 42.1599C27.2266 44.9333 23.3066 42.6666 23.3066 37.1199V32.6133Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6153137f87b74a8047348d7979b70cbb.svg";
export { ForwardRef as ReactComponent };